import { StateCreator } from "zustand";

export interface SessionTimeoutState {
    timeoutIn: number;
    open: boolean;
}

export interface SessionTimeoutSlice {
    sessionTimeout: SessionTimeoutState;
    setSessionTimeout: (state: SessionTimeoutState) => void;
    updateSessionTimeout: (partialState: Partial<SessionTimeoutState>) => void;
    openSessionTimeout: (timeoutIn: number) => void;
    closeSessionTimeout: () => void;
    decrementTimeout: () => void;
    resetSessionTimeout: () => void;
}

const initialSessionTimeoutState: SessionTimeoutState = { open: false, timeoutIn: 0 };

export const createSessionTimeoutSlice: StateCreator<SessionTimeoutSlice, [], [], SessionTimeoutSlice> = (set) => ({
    sessionTimeout: initialSessionTimeoutState,

    setSessionTimeout: (state) => set({ sessionTimeout: state }),
    updateSessionTimeout: (partialState) => set((state) => ({ sessionTimeout: { ...state.sessionTimeout, ...partialState } })),
    openSessionTimeout: (timeoutIn) => set({ sessionTimeout: { open: true, timeoutIn } }),
    closeSessionTimeout: () => set((state) => ({ sessionTimeout: { ...state.sessionTimeout, open: false } })),
    decrementTimeout: () =>
        set((state) => {
            if (state.sessionTimeout.timeoutIn === 0) return state;
            return { sessionTimeout: { ...state.sessionTimeout, timeoutIn: state.sessionTimeout.timeoutIn - 1000 } };
        }),
    resetSessionTimeout: () => set({ sessionTimeout: initialSessionTimeoutState }),
});

